<h2 i18n>Aktywne z aktualną turą</h2>
<usos-tooltip i18n>
  W tej grupie są rejestracje aktywne z aktualną turą, sortowane po kodzie rejestracji.
</usos-tooltip>

<ng-container *ngFor="let group of groupedRegistrations?.activeWithCurrentRound">
  <h3>
    [{{group.faculty.id}}] {{group.faculty.description}}
  </h3>

  <ng-container *ngFor="let registration of group.registrations">
      <app-registration [registration]="registration"></app-registration>
  </ng-container>
</ng-container>

<hr>

<h2 i18n>Z turą w przyszłości (aktywne lub przetwarzane)</h2>
<usos-tooltip i18n>
  W tej grupie są rejestracje aktywne i przetwarzane, z turą w przyszłości,
  sortowane po najbliższym terminie rozpoczęcia tury, a następnie po kodzie rejestracji.
</usos-tooltip>

<ng-container *ngFor="let group of groupedRegistrations?.activeWithNextRound">
  <h3>
    [{{group.faculty.id}}] {{group.faculty.description}}
  </h3>

  <ng-container *ngFor="let registration of group.registrations">
    <app-registration [registration]="registration"></app-registration>
  </ng-container>
</ng-container>

<hr>

<h2 i18n>Z minionymi turami</h2>
<usos-tooltip i18n>
  W tej grupie są rejestracje z minionymi turami, niezależnie od statusu,
  sortowane po kodzie rejestracji.
</usos-tooltip>

<ng-container *ngFor="let group of groupedRegistrations?.isInactiveOrFinished">
  <h3>
    [{{group.faculty.id}}] {{group.faculty.description}}
  </h3>

  <ng-container *ngFor="let registration of group.registrations">
    <app-registration [registration]="registration"></app-registration>
  </ng-container>
</ng-container>

<hr>
